// extracted by mini-css-extract-plugin
export var container = "transition-daily-module--container--94099";
export var content = "transition-daily-module--content--622f4";
export var errorText = "transition-daily-module--error-text--122ec";
export var header = "transition-daily-module--header--568ae";
export var list = "transition-daily-module--list--03169";
export var loader = "transition-daily-module--loader--f3f70";
export var loading = "transition-daily-module--loading--9a683";
export var title = "transition-daily-module--title--b0f6b";